module.exports = __webpack_public_path__ + "static/media/registerLockGuide1_Jap.94d4c266.png";